var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.6 0H4.4L0 4.429V26.57L4.4 31h13.2l4.4-4.429V4.43L17.6 0zM11 22.143c-1.215 0-2.2-.992-2.2-2.214 0-1.223.985-2.215 2.2-2.215 1.215 0 2.2.992 2.2 2.215 0 1.222-.985 2.214-2.2 2.214zm0-9.964c-1.823 0-3.3-1.487-3.3-3.322 0-1.834 1.477-3.321 3.3-3.321 1.823 0 3.3 1.487 3.3 3.321 0 .881-.348 1.726-.967 2.349-.618.623-1.458.973-2.333.973z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameCamera);
export default __webpack_public_path__ + "static/media/game-camera.35500047.svg";
export { ForwardRef as ReactComponent };